import { useEffect, useState } from "react";
import imageUtil from "../../utils/image";
import { getToMiniProgramDownloadUrl } from "../../utils/mini_program";
import { IOneGallery } from "../GalleryList/Common";
import GalleryStore from "../../store/GalleryStore";
interface IUseToMiniProgramDownloadUrl {
  type?: string;
  list: IOneGallery[];
  galleryStore: GalleryStore;
}
export default function (props: IUseToMiniProgramDownloadUrl) {
  const { type, list, galleryStore } = props;
  const [downloadUrl, setDownloadUrl] = useState("");
  useEffect(() => {
    // 其他情况不需要考虑
    if (type === "download") {
      const newList = list.map((one) => {
        const { id, hash, galleryid, show_mark } = one;
        const url = imageUtil.style(
          hash,
          "original",
          {
            watermark: galleryStore.getWatermarksByKey(
              String(galleryid),
              show_mark
            ),
          },
          id
        );
        return {
          id,
          url,
        };
      });
      const downloadLink = getToMiniProgramDownloadUrl(newList);
      setDownloadUrl(downloadLink);
    }
  }, [list, type]);
  return {
    downloadUrl,
  };
}
